/* ==========================================================================
   HUMO BARRILES · PREVENTA
   assets/preorder-escena.js

   Cambio de barril, carrito y ficha en modal. Textos en español e inglés:
   el idioma lo manda assets/humo-idioma.js y aquí se escucha humo:idioma.
   En celular el carrito sale del flujo: una barra fija abajo muestra
   artículos y total, y VER CARRITO lo abre como hoja desde abajo.
   ========================================================================== */
(function () {
  'use strict';

  var raiz = document.querySelector('[data-escena]');
  if (!raiz) return;

  var LENTO = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MS = LENTO ? 1 : (Number(raiz.dataset.duracion) || 560);
  var CURVA = 'cubic-bezier(.22,1,.36,1)';
  var DESLIZ = 90;

  var ADD = raiz.dataset.cartAddUrl || '/cart/add';
  var CAMBIO = raiz.dataset.cartChangeUrl || '/cart/change';
  var CARRITO = raiz.dataset.cartUrl || '/cart';
  var LIMPIAR = raiz.dataset.cartClearUrl || '/cart/clear';

  /* ---------- textos ---------- */
  var TXT = {
    es: {
      vacio: 'Elige un barril para empezar tu preventa.',
      carne: 'DE CARNE', para: 'PARA', humo1: '95% MENOS', humo2: 'HUMO',
      ahorra: 'AHORRA ', barril: 'AGREGAR BARRIL', agotado: 'AGOTADO',
      acc: 'AGREGAR AL CARRITO', accando: 'AGREGANDO\u2026', accok: 'AGREGADO \u2713',
      cargando: 'Cargando\u2026', noficha: 'No pudimos cargar este producto.',
      aplicando: 'Aplicando\u2026', okbarril: 'Barril agregado a tu preventa.', okacc: 'Accesorio agregado a tu preventa.',
      art1: 'ARTÍCULO', artN: 'ARTÍCULOS', verCarrito: 'VER CARRITO', cerrar: 'Cerrar'
    },
    en: {
      vacio: 'Pick a barrel to start your pre-order.',
      carne: 'OF MEAT', para: 'SERVES', humo1: '95% LESS', humo2: 'SMOKE',
      ahorra: 'SAVE ', barril: 'ADD BARREL', agotado: 'SOLD OUT',
      acc: 'ADD TO CART', accando: 'ADDING\u2026', accok: 'ADDED \u2713',
      cargando: 'Loading\u2026', noficha: 'Could not load this product.',
      aplicando: 'Applying\u2026', okbarril: 'Barrel added to your pre-order.', okacc: 'Accessory added to your pre-order.',
      art1: 'ITEM', artN: 'ITEMS', verCarrito: 'VIEW CART', cerrar: 'Close'
    }
  };
  function idioma() { return window.HUMO_IDIOMA ? window.HUMO_IDIOMA.get() : 'es'; }
  function T(k) { return TXT[idioma()][k]; }

  function leerJson(sel, porDefecto) {
    try {
      var n = raiz.querySelector(sel);
      return n ? (JSON.parse(n.textContent) || porDefecto) : porDefecto;
    } catch (e) { return porDefecto; }
  }

  var DATOS = leerJson('[data-escena-datos]', []);
  var ICOS = leerJson('[data-escena-iconos]', {});

  var vivo = raiz.querySelector('[data-vivo]');
  function decir(t) { if (vivo) vivo.textContent = t; }
  function dinero(c) { return '$' + (c / 100).toFixed(2); }
  function movil() { return window.innerWidth <= 767; }

  /* ======================================================================
     CARRITO
     ====================================================================== */
  var lineas = raiz.querySelector('[data-lineas]');
  var elSub = raiz.querySelector('[data-sub]');
  var elTotal = raiz.querySelector('[data-total]');
  var btnPagar = raiz.querySelector('[data-checkout]');
  var carro = raiz.querySelector('.hb-esc__carro');
  var ultimoCarrito = null;

  /* ---------- barra fija y hoja del carrito en celular ---------- */
  var ICO_CARRO = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 4h2.2l2.1 10.2a1.6 1.6 0 0 0 1.6 1.3h8.6a1.6 1.6 0 0 0 1.6-1.2L21 8H6.1" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="9.5" cy="19.5" r="1.5" fill="currentColor"/><circle cx="17" cy="19.5" r="1.5" fill="currentColor"/></svg>';
  var ICO_SUBE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 13l6-6 6 6M6 19l6-6 6 6" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var barra = document.createElement('div');
  barra.className = 'hb-esc__barra-movil';
  barra.innerHTML =
    '<div class="hb-esc__bm-info"><span data-bm-n></span><b data-bm-total>$0.00</b></div>' +
    '<button type="button" class="hb-esc__bm-btn" data-bm-abrir>' + ICO_CARRO + '<span data-bm-txt></span>' + ICO_SUBE + '</button>';
  raiz.appendChild(barra);
  var bmN = barra.querySelector('[data-bm-n]');
  var bmTotal = barra.querySelector('[data-bm-total]');
  var bmTxt = barra.querySelector('[data-bm-txt]');

  /* la capa oscura va en el mismo contenedor que el carrito: así queda
     debajo de la hoja y encima del resto de la sección */
  var veloCarro = document.createElement('div');
  veloCarro.className = 'hb-esc__velo-carro';
  veloCarro.setAttribute('data-velo-carro', '');
  if (carro && carro.parentNode) carro.parentNode.insertBefore(veloCarro, carro);
  else raiz.appendChild(veloCarro);

  if (carro) {
    var cerrar = document.createElement('button');
    cerrar.type = 'button';
    cerrar.className = 'hb-esc__carro-cerrar';
    cerrar.setAttribute('data-carro-cerrar', '');
    cerrar.innerHTML = '&times;';
    carro.insertBefore(cerrar, carro.firstChild);
  }

  function textosBarra(c) {
    var n = (c && c.item_count) || 0;
    bmN.textContent = n + ' ' + (n === 1 ? T('art1') : T('artN'));
    bmTotal.textContent = dinero((c && c.total_price) || 0);
    bmTxt.textContent = T('verCarrito');
    var x = raiz.querySelector('[data-carro-cerrar]');
    if (x) x.setAttribute('aria-label', T('cerrar'));
    /* la barra queda siempre visible en la preventa, aun con el carrito vacío */
    raiz.classList.add('tiene-items');
    raiz.classList.toggle('carrito-vacio', n === 0);
  }

  /* al abrir, el contenedor del carrito sube por encima de todo lo demás
     de la sección; así la hoja nunca queda debajo de la capa oscura */
  var capaCarro = carro ? carro.parentNode : null;
  function abrirCarro() {
    if (!movil()) return;
    if (capaCarro) capaCarro.style.zIndex = '70';
    raiz.classList.add('is-carro-abierto');
    document.documentElement.style.overflow = 'hidden';
  }
  function cerrarCarro() {
    if (!raiz.classList.contains('is-carro-abierto')) return;
    raiz.classList.remove('is-carro-abierto');
    document.documentElement.style.overflow = '';
    if (capaCarro) setTimeout(function () {
      if (!raiz.classList.contains('is-carro-abierto')) capaCarro.style.zIndex = '';
    }, 400);
  }
  /* ASEGURAR MI PREVENTA: la hoja se cierra antes que cualquier otro script
     (por ejemplo la oferta flash) tome el clic */
  window.addEventListener('click', function (ev) {
    if (ev.target.closest && ev.target.closest('[data-checkout]') && raiz.contains(ev.target)) cerrarCarro();
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrarCarro(); });
  window.addEventListener('resize', function () { if (!movil()) cerrarCarro(); }, { passive: true });

  /* la barra solo se muestra mientras la preventa está en pantalla */
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      en.forEach(function (x) { raiz.classList.toggle('en-pantalla', x.isIntersecting); });
    }, { threshold: 0.05 }).observe(raiz);
  } else {
    raiz.classList.add('en-pantalla');
  }

  function mini(u) { return u ? u.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : ''; }

  function pintarCarrito(c) {
    if (!lineas) return;
    ultimoCarrito = c;
    /* solo líneas con unidades reales; cada una guarda su número de línea
       original en el carrito de Shopify para cambiarla o quitarla bien */
    var visibles = (c.items || []).map(function (it, i) { return { it: it, lin: i + 1 }; })
      .filter(function (x) { return x.it && x.it.quantity > 0; });
    if (!visibles.length) {
      lineas.innerHTML = '<p class="hb-esc__vacio">' + T('vacio') + '</p>';
      if (btnPagar) btnPagar.disabled = true;
    } else {
      lineas.innerHTML = visibles.map(function (x) {
        var it = x.it, i = x.lin - 1;
        return '<article class="hb-esc__linea">' +
          (it.image ? '<img src="' + mini(it.image) + '" alt="" width="54" height="54" loading="lazy">' : '<span></span>') +
          '<div><p class="hb-esc__linea-nom">' + it.product_title + '</p>' +
            '<span class="hb-esc__linea-cant">' +
              '<button type="button" data-lin="' + (i + 1) + '" data-paso="-1" aria-label="-">&minus;</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-lin="' + (i + 1) + '" data-paso="1" aria-label="+">+</button>' +
            '</span></div>' +
          '<div class="hb-esc__linea-der">' +
            '<span class="hb-esc__linea-precio">' + dinero(it.final_line_price) + '</span>' +
            '<button type="button" class="hb-esc__quitar" data-lin="' + (i + 1) + '" data-quitar aria-label="x">&times;</button>' +
          '</div></article>';
      }).join('');
      if (btnPagar) btnPagar.disabled = false;
    }

    if (elSub) elSub.textContent = dinero(c.items_subtotal_price || 0);
    if (elTotal) {
      elTotal.textContent = dinero(c.total_price || 0);
      elTotal.classList.remove('is-pulso');
      void elTotal.offsetWidth;
      elTotal.classList.add('is-pulso');
    }

    var filaD = raiz.querySelector('[data-fila-desc]');
    var elD = raiz.querySelector('[data-desc]');
    var dd = c.total_discount || 0;
    if (filaD) filaD.hidden = dd <= 0;
    if (elD && dd > 0) elD.textContent = '-' + dinero(dd);

    textosBarra(c);

    document.dispatchEvent(new CustomEvent('humo:carrito-cambio'));
  }

  /* pulso de la barra cuando entra algo nuevo */
  function avisarBarra() {
    if (!movil()) return;
    barra.classList.remove('is-pulso');
    void barra.offsetWidth;
    barra.classList.add('is-pulso');
  }

  function leer() {
    return fetch(CARRITO + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(pintarCarrito)
      .catch(function () {});
  }

  function agregar(vid, cant) {
    return fetch(ADD + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: cant || 1 }] })
    }).then(function (r) { return r.json(); }).then(leer).then(avisarBarra);
  }

  function cambiarLinea(linea, cant) {
    return fetch(CAMBIO + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(linea), quantity: cant })
    }).then(function (r) { return r.json(); }).then(pintarCarrito);
  }

  /* ======================================================================
     SELECTOR Y BARRIL
     ====================================================================== */
  var pista = raiz.querySelector('[data-sel-pista]');
  var items = pista ? Array.prototype.slice.call(pista.children) : [];
  var total = items.length;
  var barriles = Array.prototype.slice.call(raiz.querySelectorAll('[data-barril]'));
  var humo = raiz.querySelector('.hb-esc__humo');
  var actual = 0;
  var ocupado = false;
  var PASO = 96;

  function desfase() { return total % 2 === 0 ? PASO / 2 : 0; }

  function colocar() {
    if (!pista || !total) return;
    var medio = Math.floor(total / 2);
    for (var i = 0; i < total; i++) {
      pista.appendChild(items[(actual - medio + i + total * 2) % total]);
    }
    pista.style.transition = 'none';
    pista.style.transform = movil()
      ? 'translate3d(calc(-50% + ' + desfase() + 'px), 0, 0)'
      : 'translate3d(0, calc(-50% + ' + desfase() + 'px), 0)';
    for (var k = 0; k < total; k++) {
      var on = k === actual;
      items[k].classList.toggle('is-on', on);
      items[k].setAttribute('aria-selected', String(on));
    }
  }

  var iTit = raiz.querySelector('[data-info-titulo]');
  var iSub = raiz.querySelector('[data-info-sub]');
  var iBen = raiz.querySelector('[data-info-benes]');
  var iPre = raiz.querySelector('[data-info-precio]');
  var iAnt = raiz.querySelector('[data-info-antes]');
  var iAho = raiz.querySelector('[data-info-ahorro]');
  var btnAdd = raiz.querySelector('[data-add-barril]');
  var campoCant = raiz.querySelector('[data-cant-campo]');

  function carneEs(s) { return s.replace(/^\s*up to/i, 'Hasta'); }
  function genteEs(s) { return s.replace(/\bto\b/i, 'a').replace(/people/i, 'personas'); }

  function llenar(d) {
    if (!d) return;
    var es = idioma() === 'es';
    if (iTit) { iTit.textContent = es ? (d.titulo_es || d.titulo) : d.titulo; iTit.dataset.pdp = d.h; }
    if (iSub) iSub.textContent = (es ? (d.sub_es || d.sub) : d.sub) || '';
    if (iBen) {
      var html = '';
      if (d.carne) html += '<li><img src="' + ICOS.carne + '" alt="" width="50" height="50"><span>' +
        (es ? carneEs(d.carne) : d.carne) + '<br>' + T('carne') + '</span></li>';
      if (d.gente) html += '<li><img src="' + ICOS.gente + '" alt="" width="50" height="50"><span>' +
        T('para') + '<br>' + (es ? genteEs(d.gente) : d.gente) + '</span></li>';
      html += '<li><img src="' + ICOS.humo + '" alt="" width="50" height="50"><span>' + T('humo1') + '<br>' + T('humo2') + '</span></li>';
      iBen.innerHTML = html;
    }
    if (iPre) iPre.textContent = dinero(d.precio);
    if (iAnt) iAnt.textContent = d.antes > d.precio ? dinero(d.antes) : '';
    if (iAho) iAho.textContent = d.antes > d.precio
      ? T('ahorra') + Math.round((d.antes - d.precio) / d.antes * 100) + '%' : '';
    if (btnAdd) {
      btnAdd.textContent = d.hay ? T('barril') : T('agotado');
      btnAdd.disabled = !d.hay;
      btnAdd.dataset.vid = d.vid;
    }
  }

  function pintarInfo(k) {
    var d = DATOS[k];
    if (!d) return;

    var piezas = [
      iTit && iTit.parentNode, iSub, iBen,
      raiz.querySelector('.hb-esc__precios'),
      raiz.querySelector('.hb-esc__compra')
    ];

    if (!LENTO) {
      piezas.forEach(function (el) {
        if (!el) return;
        el.style.transition = 'opacity ' + (MS * .28) + 'ms ease, transform ' + (MS * .28) + 'ms ease';
        el.style.opacity = '0';
        el.style.transform = 'translateY(10px)';
      });
    }

    setTimeout(function () {
      llenar(d);
      if (!LENTO) {
        piezas.forEach(function (el, n) {
          if (!el) return;
          setTimeout(function () { el.style.opacity = '1'; el.style.transform = ''; }, n * 65);
        });
      }
    }, LENTO ? 0 : MS * .28);
  }

  function cambiarBarril(nuevo) {
    var sale = barriles[actual];
    var entra = barriles[nuevo];
    if (!entra) return;

    if (LENTO) {
      barriles.forEach(function (b, k) { b.classList.toggle('is-on', k === nuevo); });
      pintarInfo(nuevo);
      return;
    }

    if (sale && sale !== entra) {
      sale.style.transition = 'opacity ' + (MS * .5) + 'ms ease, transform ' + (MS * .7) + 'ms ' + CURVA;
      sale.style.transform = 'translateX(' + DESLIZ + 'px) scale(calc(var(--e,100) / 100))';
      sale.style.opacity = '0';
      setTimeout(function () {
        sale.classList.remove('is-on');
        sale.style.transition = 'none';
        sale.style.transform = '';
        sale.style.opacity = '';
      }, MS * .75);
    }

    entra.classList.add('is-on');
    entra.style.transition = 'none';
    entra.style.transform = 'translateX(' + (-DESLIZ) + 'px) scale(calc(var(--e,100) / 100))';
    entra.style.opacity = '0';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        entra.style.transition = 'opacity ' + (MS * .6) + 'ms ease ' + (MS * .25) + 'ms, transform ' + MS + 'ms ' + CURVA + ' ' + (MS * .2) + 'ms';
        entra.style.transform = '';
        entra.style.opacity = '1';
      });
    });

    if (humo) {
      humo.style.transition = 'opacity ' + (MS * .5) + 'ms ease';
      humo.style.opacity = '.62';
      setTimeout(function () { humo.style.opacity = ''; }, MS * .8);
    }

    pintarInfo(nuevo);
  }

  function irA(pedido) {
    if (ocupado || total < 2) return;
    var destino = ((pedido % total) + total) % total;
    if (destino === actual) return;
    ocupado = true;

    var bruto = destino - actual;
    var dir = bruto > 0 ? 1 : -1;
    if (Math.abs(bruto) > total / 2) dir *= -1;

    if (pista && !LENTO) {
      var d = desfase() - dir * PASO;
      pista.style.transition = 'transform ' + MS + 'ms ' + CURVA;
      pista.style.transform = movil()
        ? 'translate3d(calc(-50% + ' + d + 'px), 0, 0)'
        : 'translate3d(0, calc(-50% + ' + d + 'px), 0)';
    }

    cambiarBarril(destino);

    setTimeout(function () {
      actual = destino;
      colocar();
      ocupado = false;
    }, LENTO ? 10 : MS);
  }

  /* ======================================================================
     FICHA EN MODAL
     ====================================================================== */
  var modal = raiz.querySelector('[data-pdp-modal]');
  var cuerpoModal = raiz.querySelector('[data-pdp-cuerpo]');
  var ultimoFoco = null;

  function montarFicha() {
    if (!cuerpoModal) return;
    if (window.HUMO_IDIOMA) window.HUMO_IDIOMA.aplicar(cuerpoModal);

    var gal = cuerpoModal.querySelector('[data-gal]');
    var puntos = cuerpoModal.querySelectorAll('[data-gal-punto]');
    if (!gal || !puntos.length) return;

    var espera = null;
    gal.addEventListener('scroll', function () {
      clearTimeout(espera);
      espera = setTimeout(function () {
        var i = Math.round(gal.scrollLeft / Math.max(1, gal.clientWidth));
        for (var k = 0; k < puntos.length; k++) puntos[k].classList.toggle('is-on', k === i);
      }, 60);
    }, { passive: true });
  }

  function abrirPdp(handle, origen) {
    if (!modal || !handle) return;
    ultimoFoco = origen || document.activeElement;
    cuerpoModal.innerHTML = '<p class="hb-esc__vacio">' + T('cargando') + '</p>';
    if (typeof modal.showModal === 'function') modal.showModal();
    document.documentElement.style.overflow = 'hidden';

    fetch('/products/' + handle + '?view=quick', { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) { cuerpoModal.innerHTML = html; montarFicha(); })
      .catch(function () {
        cuerpoModal.innerHTML = '<p class="hb-esc__vacio">' + T('noficha') + '</p>';
      });
  }

  function cerrarPdp() {
    if (!modal) return;
    if (modal.open) modal.close();
    document.documentElement.style.overflow = raiz.classList.contains('is-carro-abierto') ? 'hidden' : '';
    cuerpoModal.innerHTML = '';
    if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
    leer();
  }

  if (modal) {
    modal.addEventListener('click', function (ev) { if (ev.target === modal) cerrarPdp(); });
    modal.addEventListener('cancel', function (ev) { ev.preventDefault(); cerrarPdp(); });
    modal.addEventListener('close', function () {
      document.documentElement.style.overflow = raiz.classList.contains('is-carro-abierto') ? 'hidden' : '';
    });
  }

  function textoBoton(btn, porDefecto) {
    return btn.getAttribute('data-' + idioma()) || porDefecto;
  }

  /* ======================================================================
     CLIC ÚNICO
     ====================================================================== */
  raiz.addEventListener('click', function (ev) {
    var t = ev.target;

    /* carrito en celular */
    if (t.closest('[data-bm-abrir]')) { abrirCarro(); return; }
    if (t.closest('[data-carro-cerrar]') || t === veloCarro) { cerrarCarro(); return; }

    /* carrusel de la ficha */
    var galIr = t.closest('[data-gal-ir]');
    if (galIr) {
      var galA = galIr.parentNode.querySelector('[data-gal]');
      if (galA) galA.scrollBy({ left: Number(galIr.dataset.galIr) * galA.clientWidth, behavior: LENTO ? 'auto' : 'smooth' });
      return;
    }
    var galPunto = t.closest('[data-gal-punto]');
    if (galPunto) {
      var galB = galPunto.closest('.hb-pdp__gal').querySelector('[data-gal]');
      if (galB) galB.scrollTo({ left: Number(galPunto.dataset.galPunto) * galB.clientWidth, behavior: LENTO ? 'auto' : 'smooth' });
      return;
    }

    var flecha = t.closest('[data-sel-ir]');
    if (flecha) { irA(actual + Number(flecha.dataset.selIr)); return; }

    var op = t.closest('[data-sel-op]');
    if (op) { irA(Number(op.dataset.selOp)); return; }

    var cnt = t.closest('[data-cant]');
    if (cnt && campoCant) {
      campoCant.value = Math.max(1, (parseInt(campoCant.value, 10) || 1) + Number(cnt.dataset.cant));
      return;
    }

    var accCnt = t.closest('[data-acc-cant]');
    if (accCnt) {
      var campoAcc = accCnt.parentNode.querySelector('[data-acc-cantidad]');
      if (campoAcc) {
        campoAcc.value = Math.max(1, (parseInt(campoAcc.value, 10) || 1) + Number(accCnt.dataset.accCant));
      }
      return;
    }

    var add = t.closest('[data-add-barril]');
    if (add && !add.disabled) {
      add.disabled = true;
      var q = Math.max(1, parseInt(campoCant ? campoCant.value : 1, 10) || 1);
      agregar(add.dataset.vid, q).then(function () {
        add.disabled = false;
        decir(T('okbarril'));
      });
      return;
    }

    var acc = t.closest('[data-add-acc]');
    if (acc && !acc.disabled) {
      acc.disabled = true;
      var tarjeta = acc.closest('[data-acc-item]');
      var campoQ = tarjeta && tarjeta.querySelector('[data-acc-cantidad]');
      var qa = Math.max(1, parseInt(campoQ ? campoQ.value : 1, 10) || 1);
      acc.textContent = T('accando');
      agregar(acc.dataset.addAcc, qa).then(function () {
        if (tarjeta) tarjeta.classList.add('is-hecho');
        acc.textContent = T('accok');
        decir(T('okacc'));
        setTimeout(function () {
          acc.disabled = false;
          acc.textContent = textoBoton(acc, T('acc'));
          if (campoQ) campoQ.value = 1;
          if (tarjeta) tarjeta.classList.remove('is-hecho');
        }, 1700);
      }).catch(function () {
        acc.disabled = false;
        acc.textContent = textoBoton(acc, T('acc'));
      });
      return;
    }

    /* solo los botones de más y menos de una línea del carrito */
    var p = t.closest('[data-lin][data-paso]');
    if (p) {
      var fila = p.closest('.hb-esc__linea');
      var q2 = parseInt(fila.querySelector('.hb-esc__linea-cant span').textContent, 10) || 1;
      cambiarLinea(p.dataset.lin, Math.max(0, q2 + Number(p.dataset.paso)));
      return;
    }

    var quitar = t.closest('[data-quitar]');
    if (quitar) { cambiarLinea(quitar.dataset.lin, 0); return; }

    if (t.closest('[data-vaciar]')) {
      fetch(LIMPIAR + '.js', { method: 'POST', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); }).then(pintarCarrito);
      return;
    }

    if (t.closest('[data-checkout]')) { cerrarCarro(); window.location.href = '/checkout'; return; }

    if (t.closest('[data-ir-accesorios]')) {
      cerrarCarro();
      var zona = raiz.querySelector('[data-acc]');
      if (zona) zona.scrollIntoView({ behavior: LENTO ? 'auto' : 'smooth', block: 'center' });
      return;
    }

    var mando = t.closest('[data-acc-ir]');
    if (mando) {
      var lista = raiz.querySelector('[data-acc-pista]');
      var uno = lista && lista.querySelector('.hb-esc__acc-item');
      if (lista && uno) {
        var ancho = uno.getBoundingClientRect().width + 20;
        lista.scrollBy({ left: Number(mando.dataset.accIr) * ancho * (movil() ? 1 : 3), behavior: LENTO ? 'auto' : 'smooth' });
      }
      return;
    }

    if (t.closest('[data-pdp-cerrar]')) { cerrarPdp(); return; }

    var disparo = t.closest('[data-pdp]');
    if (disparo && disparo.dataset.pdp) { abrirPdp(disparo.dataset.pdp, disparo); return; }
  });

  /* ---------- rueda, gestos y teclado ---------- */
  var ventana = raiz.querySelector('.hb-esc__sel-ventana');
  if (ventana) {
    ventana.addEventListener('wheel', function (ev) {
      if (ocupado || Math.abs(ev.deltaY) < 14) return;
      ev.preventDefault();
      irA(actual + (ev.deltaY > 0 ? 1 : -1));
    }, { passive: false });

    var tX = 0, tY = 0;
    ventana.addEventListener('touchstart', function (e) {
      tX = e.touches[0].clientX; tY = e.touches[0].clientY;
    }, { passive: true });
    ventana.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - tX;
      var dy = e.changedTouches[0].clientY - tY;
      var dd = movil() ? dx : dy;
      if (Math.abs(dd) > 36) irA(actual + (dd < 0 ? 1 : -1));
    }, { passive: true });

    ventana.addEventListener('keydown', function (ev) {
      if (ev.key === 'ArrowDown' || ev.key === 'ArrowRight') { ev.preventDefault(); irA(actual + 1); }
      if (ev.key === 'ArrowUp' || ev.key === 'ArrowLeft') { ev.preventDefault(); irA(actual - 1); }
    });
  }

  /* ---------- código de descuento ---------- */
  var btnCod = raiz.querySelector('[data-aplicar]');
  if (btnCod) {
    btnCod.addEventListener('click', function () {
      var campo = raiz.querySelector('[data-codigo]');
      var msg = raiz.querySelector('[data-codigo-msg]');
      var cod = (campo.value || '').trim();
      if (!cod) return;
      if (msg) msg.textContent = T('aplicando');
      window.location.href = '/discount/' + encodeURIComponent(cod) +
        '?redirect=' + encodeURIComponent(window.location.pathname);
    });
  }

  /* ---------- cambio de idioma ---------- */
  document.addEventListener('humo:idioma', function () {
    llenar(DATOS[actual]);
    if (ultimoCarrito) pintarCarrito(ultimoCarrito);
    else textosBarra(null);
  });

  /* ======================================================================
     ARRANQUE
     ====================================================================== */
  textosBarra(null);
  colocar();
  llenar(DATOS[actual]);
  leer();

  var tempo = null;
  window.addEventListener('resize', function () {
    clearTimeout(tempo);
    tempo = setTimeout(colocar, 150);
  }, { passive: true });
})();
